import { useEffect } from "react";
import ServiceUnavailable from "../../components/ServiceUnavailable/ServiceUnavailable";
import useReactGASend from "../../hooks/useReactGASend";

const MaintenancePage = () => {
  const { makeEventTrackFn } = useReactGASend();

  useEffect(() => {
    makeEventTrackFn({
      category: "event",
      action: "서비스 이용 불가 페이지 인입",
    });
  }, []);

  return (
    <ServiceUnavailable
      title="서비스 점검 중입니다."
      description={
        <>
          서비스 점검 중입니다.
          <br /> 잠시 후 다시 이용해 주세요.
        </>
      }
    />
  );
};

export default MaintenancePage;
